import getRouterBasename from '@/lib/router';
import App from 'App';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useApi,
  useAuth,
  useChatInteract,
  useConfig
} from '@chainlit/react-client';

export default function AppWrapper() {
  const [translationLoaded, setTranslationLoaded] = useState(false);
  const { isAuthenticated, isReady } = useAuth();
  const { language: languageInUse } = useConfig();
  const { i18n } = useTranslation();
  const { windowMessage } = useChatInteract();

  const handleChangeLanguage = useCallback(
    (languageBundle: any): void => {
      i18n.addResourceBundle(languageInUse, 'translation', languageBundle);
      i18n.changeLanguage(languageInUse);
    },
    [i18n, languageInUse]
  ); // Memoize to prevent unnecessary re-renders

  const { data: translations } = useApi<any>(
    `/project/translations?language=${languageInUse}`
  );

  useEffect(() => {
    if (!translations) return;
    handleChangeLanguage(translations.translation);
    setTranslationLoaded(true);
  }, [translations, languageInUse]); // Add languageInUse dependency

  useEffect(() => {
    const handleWindowMessage = (event: MessageEvent) => {
      windowMessage(event.data);
    };
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, [windowMessage]);

  if (!translationLoaded) return null;

  const publicAuthPaths = [
    '/welcome',
    '/login',
    '/login/callback',
    '/signup',
    '/signup/success',
    '/forgot-password',
    '/reset-password',
    '/support'
  ];
  const currentPath = window.location.pathname.replace(
    new RegExp(`^${getRouterBasename()}`),
    ''
  );
  if (isReady && !isAuthenticated && !publicAuthPaths.includes(currentPath)) {
    window.location.href = getRouterBasename() + '/welcome';
  }
  return <App />;
}
